// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__OauJ0","header":"styles_header__-xQ9D","form":"styles_form__VnW8g"};